import posthog from 'posthog-js'

const API_KEY = process.env.REACT_APP_POSTHOG_PROJECT_API_KEY ?? ''
const API_HOST = process.env.REACT_APP_PUBLIC_POSTHOG_HOST ?? 'https://us.i.posthog.com'
const UI_HOST = 'https://us.posthog.com'

posthog.init(API_KEY, {
  api_host: API_HOST,
  ui_host: UI_HOST,
})

export default posthog
